import React, { forwardRef, memo } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import styles from "./ToggleInput.scss";

/* eslint-disable-next-line react/display-name */
export const ToggleInput = memo(
  forwardRef(({ className, label, description, disabled, ...rest }, ref) => {
    return (
      <div className={className}>
        <p className={classNames(styles.label,'title')}>{label}</p>
        <label className={classNames(styles.toggleInput, { [styles.disabled]: disabled })}>
        
          <input type="checkbox" disabled={disabled} ref={ref} {...rest} />
          <div className={classNames(styles.track, 'track')}>
            <div className={classNames(styles.button, 'track-button')} />
          </div>
          {label && (
            <div className={styles.labelContainer}>
              {description && <p className={classNames(styles.description, 'description')}>{description}</p>}
            </div>
          )}
        </label>
      </div>
    );
  })
);

ToggleInput.propTypes = {
  label: PropTypes.node,
  description: PropTypes.node,
  checked: PropTypes.bool,
  disabled: PropTypes.bool,
  className: PropTypes.string
};
